import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <NavStyle>
      <h1>
        <Link id="Logo" to="/">
          MODERN
        </Link>
      </h1>
      <ul>
        <li>
          <Link to="/">1. About Us</Link>
        </li>
        <li>
          <Link to="/work">2. Our Work</Link>
        </li>
        <li>
          <Link className="third" to="/contact">
            3. Contact Us
          </Link>
        </li>
      </ul>
    </NavStyle>
  );
};

const NavStyle = styled.nav`
  min-height: 10vh;
  display: flex;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 10rem;
  background-color: #252525;

  a {
    color: white;
    text-decoration: none;
  }
  ul {
    display: flex;
    list-style: none;
  }
  #Logo {
    font-size: 1.5rem;
    font-family: "Raleway", sans-serif;
    color: #ffffff;
    font-weight: bold;
  }
  li {
    padding-left: 8rem;
    position: relative;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 2rem 0rem;
    ul {
      padding: 2rem;
      justify-content: space-around;
      width: 100%;
    }
    li {
      padding: 0;
      font-size: 1.5rem;
    }
  }
`;

export default Nav;
